import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { CHeader, CHeaderBrand, CHeaderNav, CNavItem, CNavLink, CContainer, CHeaderToggler } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { cilMenu } from '@coreui/icons';

import BreadCrumbRouter from '../../components/General/BreadCrumbRouter';
import SystemAdminAccountDropdown from './TheAccountDropdown';

import { setSidebarShow, toggleTheme } from '../../actions/general';

// routes config
import { systemAdminRoutes } from '../../routes';
import { USER_ROLES } from '../../constants';

const SystemAdminHeader = (props) => {
     const { general, setSidebarShow } = props;

     const handleToggleSidebar = () => {
          setSidebarShow(!general.sidebarShow);
     };

     return (
          <CHeader className={general.overlay ? 'open-dropdown' : ''} position="sticky">
               <CHeaderToggler className="ps-0" onClick={handleToggleSidebar}>
                    <CIcon icon={cilMenu} size="lg" />
               </CHeaderToggler>
               <CHeaderBrand className="mx-auto d-lg-none" to="/">
                    <CIcon icon="logo" height={48} alt="Logo" />
               </CHeaderBrand>
               <CHeaderNav className="d-none d-md-flex me-auto">
                    <CNavItem>
                         <CNavLink to="/" component={NavLink}>
                              System Admin
                         </CNavLink>
                    </CNavItem>
               </CHeaderNav>
               <CHeaderNav className="px-3">
                    <SystemAdminAccountDropdown />
               </CHeaderNav>
               <CContainer fluid>
                    <BreadCrumbRouter routes={systemAdminRoutes} role={USER_ROLES.SYSTEM_ADMIN} />
               </CContainer>
          </CHeader>
     );
};

const mapStateToProps = (state) => {
     return {
          general: state.general,
          systemAdmin: state.admin,
     };
};

const mapDispatchToProps = {
     toggleTheme,
     setSidebarShow,
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(SystemAdminHeader));
